// extracted by mini-css-extract-plugin
module.exports = {"root":"_97ef5b4","image":"_c74f967","content":"_8a24fa0","name":"_b002a07","info":"_18ca14e","item":"_e8b452a","label":"_952e7d0","value":"_adb66da"};